module.exports = __webpack_public_path__ + "img/wx.133bad23.svg";